export default {
  type: 'input',
  name: '输入框',
  components: 'ElInput',
  icon: '',
  tips: '这是一个输入框',
  configList: ['BasicConfig'],
  options: {}
}
